export type GlossaryTerm = {
  id: string;
  term: string;
  definition: string;
};

export const GLOSSARY_TERMS: GlossaryTerm[] = [
  {
    id: "deductible",
    term: "Deductible",
    definition:
      "The amount you pay for covered health care services before your insurance plan starts to pay. For example, with a $1,500 deductible, you pay the first $1,500 of covered services yourself.",
  },
  {
    id: "oop-max",
    term: "Out-of-Pocket Maximum",
    definition:
      "The most you have to pay for covered services in a plan year. After you spend this amount on deductibles, copays, and coinsurance, your health plan pays 100% of the costs of covered benefits.",
  },
  {
    id: "coinsurance",
    term: "Coinsurance",
    definition:
      "Your share of the costs of a covered health care service, calculated as a percentage. For example, if your plan’s coinsurance is 20%, you pay 20% of the cost and your plan pays 80%.",
  },
  {
    id: "copay",
    term: "Copay",
    definition:
      "A fixed amount you pay for a covered health care service after you’ve paid your deductible. For example, a $25 copay for a doctor’s visit.",
  },
  {
    id: "eob",
    term: "Explanation of Benefits (EOB)",
    definition:
      "A statement from your health insurance plan describing what costs it will cover for medical care or products you’ve received. The EOB is not a bill but shows how much was billed, how much was covered, and how much you may owe.",
  },
  {
    id: "prior-auth",
    term: "Prior Authorization",
    definition:
      "Approval from your insurance company before you receive certain services or medications. Without prior authorization, your insurance may not cover the cost.",
  },
  {
    id: "in-network",
    term: "In-Network",
    definition:
      "Providers or facilities that have contracted with your health plan to provide services at discounted rates. Using in-network providers typically costs less than using out-of-network providers.",
  },
  {
    id: "lifetime-max",
    term: "Lifetime Maximum",
    definition:
      "The maximum amount your insurance will pay for fertility treatments over your lifetime. Once reached, you are responsible for all additional costs.",
  },
  {
    id: "allowed-amount",
    term: "Allowed Amount",
    definition:
      "The maximum amount your plan will pay for a covered health care service. This is also called the ‘eligible expense,’ ‘payment allowance,’ or ‘negotiated rate.’",
  },
  {
    id: "claim",
    term: "Claim",
    definition:
      "A request for payment submitted to your insurance company for health care services you received. Claims detail the services provided and the charges.",
  },
  {
    id: "premium",
    term: "Premium",
    definition:
      "The amount you pay each month to keep your health insurance active. You usually pay your premium even when you do not use health care, and it is separate from your deductible, copays, and coinsurance.",
  },
  {
    id: "out-of-network",
    term: "Out-of-Network",
    definition:
      "A provider or facility that does not have a contracted rate with your health plan. Out-of-network care may cost more, may have different benefits, or may not count toward your plan’s in-network limits.",
  },
  {
    id: "balance-billing",
    term: "Balance Billing",
    definition:
      "When a provider bills you for the difference between their charge and your plan’s allowed amount. In-network providers generally agree not to balance bill you for covered services.",
  },
  {
    id: "excluded-services",
    term: "Excluded Services",
    definition:
      "Health care services your plan does not cover. Amounts you pay for excluded services generally do not count toward your deductible or out-of-pocket maximum.",
  },
  {
    id: "patient-responsibility",
    term: "Patient Responsibility",
    definition:
      "The amount you may owe after your plan processes a claim. It can include your deductible, copay, coinsurance, or services your plan does not cover.",
  },
];
